import useEditingStore from '@hooks/useEditingStore';
import { $tourData } from '@stores/dataStores';
import {
  $GateSearchBtn,
  $editingFlag,
  $editingUIColor,
} from '@stores/editingStores';
import { TemplateId } from '@types';
import { getTemplateConfig } from '@utils/templateConfig';

export function WButtonsREB() {
  const flag = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.flag,
    $editing: $editingFlag.store,
  });
  const showSearch = useEditingStore({
    $data: $tourData,
    dataFn: (state) => !!state.config?.search?.enabled,
    $editing: $GateSearchBtn.state,
  });
  const ui = useEditingStore({
    $data: $tourData,
    dataFn: (state) => {
      const ui = state.config?.ui;
      const defaultUI =
        getTemplateConfig(TemplateId.realEstateB)('uiColor') ?? {};
      if (!ui) return defaultUI;
      return { ...defaultUI, ...ui };
    },
    $editing: $editingUIColor.store,
  });

  const showShare = !!(flag?.showShareBtn ?? 1);
  const showLike = !!(flag?.showLikeBtn ?? 1);
  const showCommentBtn = !!(flag?.showCommentBtnV2 ?? 1);

  const color = `rgba(${ui.fontColor})`;

  return (
    <div className="absolute right-30 top-24 flex flex-col items-center">
      <div
        className="flex w-40 flex-col items-center rounded-full py-15 gap-15"
        style={{
          backgroundColor: `rgba(${ui.panelBgColor})`,
        }}
      >
        {showLike && (
          <svg width={20} height={20}>
            <path
              fill={color}
              fillRule="evenodd"
              d="m9.994 3.703-.887-.887a5.334 5.334 0 1 0-7.54 7.55l1.104 1.104 7.128 7.128a.294.294 0 0 0 .422 0l7.129-7.128 1.103-1.104a5.354 5.354 0 0 0-.021-7.55 5.334 5.334 0 0 0-7.551 0zm7.023.527q-.98-.98-2.36-.98-1.382 0-2.362.98L9.994 6.531 7.693 4.23q-.98-.98-2.361-.98t-2.361.98Q1.999 5.207 2 6.59q.001 1.382.981 2.362l1.104 1.104 5.925 5.925 5.926-5.925 1.103-1.104q.964-.974.961-2.357-.003-1.385-.983-2.365"
            />
          </svg>
        )}
        {showShare && (
          <svg width={20} height={20}>
            <defs>
              <clipPath id="prefixed1V7kfwGG-NIJviKVCXVa">
                <rect width="20" height="20" rx="0" />
              </clipPath>
            </defs>
            <g clipPath="url(#prefixed1V7kfwGG-NIJviKVCXVa)">
              <path
                fill={color}
                d="M10.108.91c.108 0 .213.04.294.113l8.545 7.774c.164.15.189.396.067.575l-.036.047q-.01.012-8.577 7.806a.436.436 0 0 1-.619-.031.44.44 0 0 1-.113-.296v-4.51q-.61.017-1.197.115l-.117.02c-3.236.591-5.836 2.465-6.7 5.614l-.067-.143c-.256-.58-.679-1.773-.679-2.963 0-4.965 3.884-9.016 8.76-9.246V1.35a.44.44 0 0 1 .44-.44zm1.166 3.076v3.33l-1.529.071c-3.52.166-6.401 2.744-7.08 6.115 1.41-1.292 3.265-2.166 5.414-2.558l.128-.022q.706-.12 1.423-.137l1.644-.042v3.52l5.647-5.14z"
              />
            </g>
          </svg>
        )}
        {showSearch && (
          <svg width={20} height={20}>
            <defs>
              <clipPath id="prefixJW5P2BiOf8rdB8_5SvO71a">
                <rect width="20" height="20" rx="0" />
              </clipPath>
            </defs>
            <g clipPath="url(#prefixJW5P2BiOf8rdB8_5SvO71a)">
              <path
                fill={color}
                fillRule="evenodd"
                d="M8.375 15.853a7 7 0 1 0 0-14 7 7 0 0 0 0 14M11.557 5.67q1.318 1.318 1.318 3.182t-1.318 3.182-3.182 1.318-3.182-1.318-1.318-3.182T5.193 5.67t3.182-1.318 3.182 1.318m4.934 12.11-.013-.013-1.5-1.544a1.25 1.25 0 0 1 1.78-1.755l.014.013 1.5 1.544a1.25 1.25 0 0 1-1.78 1.755"
              />
            </g>
          </svg>
        )}
        {showCommentBtn && (
          <svg width={20} height={20}>
            <defs>
              <clipPath id="prefixAM75UKmonRdtPCnn3uw7Ra">
                <rect width="20" height="20" rx="0" />
              </clipPath>
            </defs>
            <g clipPath="url(#prefixAM75UKmonRdtPCnn3uw7Ra)">
              <path
                fill={color}
                d="M5.455 10a.91.91 0 1 0 1.818 0 .91.91 0 0 0-1.818 0m3.636 0a.91.91 0 1 0 1.818 0 .91.91 0 0 0-1.818 0m3.636 0a.91.91 0 1 0 1.819 0 .91.91 0 0 0-1.819 0m6.496-3.875A10 10 0 0 0 13.875.777 10 10 0 0 0 10 0h-.045A9.976 9.976 0 0 0 0 10.047a10 10 0 0 0 1.072 4.462v3.393c0 .567.46 1.027 1.026 1.027h3.395A10 10 0 0 0 9.955 20h.047c1.337 0 2.634-.259 3.855-.766a9.9 9.9 0 0 0 3.188-2.125A9.98 9.98 0 0 0 20 10.044a10 10 0 0 0-.777-3.919m-3.462 9.686a8.14 8.14 0 0 1-5.763 2.366H9.96a8.2 8.2 0 0 1-3.807-.956l-.184-.1H2.874v-3.095l-.1-.185a8.2 8.2 0 0 1-.956-3.806 8.13 8.13 0 0 1 2.366-5.8 8.12 8.12 0 0 1 5.779-2.417H10a8.14 8.14 0 0 1 5.787 2.395 8.151 8.151 0 0 1 2.395 5.822 8.15 8.15 0 0 1-2.421 5.776"
              />
            </g>
          </svg>
        )}
        <svg width={20} height={20}>
          <path
            fill={color}
            d="M12.674 0a9.9 9.9 0 0 1 4.134 2.407 3.2 3.2 0 0 0-.308 1.378c0 1.724 1.343 3.121 3 3.121h.042c.298.986.458 2.034.458 3.122q-.002 1.078-.203 2.095a3 3 0 0 0-.297-.015c-1.657 0-3 1.398-3 3.121 0 .767.265 1.469.706 2.012A9.94 9.94 0 0 1 12.858 20c-.387-1.259-1.52-2.17-2.858-2.17s-2.471.912-2.858 2.17a9.94 9.94 0 0 1-4.348-2.76c.44-.542.706-1.244.706-2.01 0-1.724-1.343-3.122-3-3.122q-.15 0-.297.015a10.86 10.86 0 0 1 .255-5.217H.5c1.657 0 3-1.397 3-3.12 0-.495-.11-.963-.308-1.38A9.9 9.9 0 0 1 7.326 0C7.822 1.012 8.833 1.705 10 1.705S12.178 1.012 12.674 0M10 6.386c-1.933 0-3.5 1.63-3.5 3.641S8.067 13.67 10 13.67s3.5-1.63 3.5-3.642c0-2.01-1.567-3.64-3.5-3.64"
          />
        </svg>
        <div className="h-1 w-16 bg-white bg-opacity-50" />
        <svg width={20} height={20}>
          <path
            fill={color}
            fillRule="evenodd"
            d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10m5.303-15.303Q17.5 6.893 17.5 10t-2.197 5.303Q13.107 17.5 10 17.5t-5.303-2.197Q2.5 13.107 2.5 10t2.197-5.303Q6.893 2.5 10 2.5t5.303 2.197M6.25 7.5a1.25 1.25 0 1 1 2.5 0v5a1.25 1.25 0 1 1-2.5 0zm5 0a1.25 1.25 0 1 1 2.5 0v5a1.25 1.25 0 1 1-2.5 0z"
          />
        </svg>
      </div>
    </div>
  );
}
